import { defineStore } from 'pinia';
import axios from 'axios';
import to from 'await-to-js';
// TODO: aov3-8283 fix circular dependency issue
// eslint-disable-next-line import/no-cycle
import { useContextStore } from './context';

export const useUserNotificationsStore = defineStore('userNotifications', {
  state: () => ({
    userNotifications: [],
    loading: false,
  }),

  getters: {
    getUserNotifications: state => state.userNotifications,
    getLoading: state => state.loading,
  },

  actions: {
    async fetchUserNotifications(params = {}) {
      const contextStore = useContextStore();
      if (!contextStore.profile) return;
      this.loading = true;
      const [err, { data: userNotifications } = {}] = await to(
        axios.get('/api/user-notifications/user', { params })
      );
      if (err) throw new Error(err.message);
      this.userNotifications = userNotifications;
      this.loading = false;
    },

    async updateUserNotifications(updates = {}) {
      this.loading = true;
      const [err] = await to(axios.patch('/api/user-notifications', updates));
      if (err) throw new Error(err.message);
      this.fetchUserNotifications();
    },
  },
});
